import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { globalApi } from "./state/globalApi";
import globalReducer from "./state/globalStore";
import { queryApis } from "./state/query-api";
import queryReducer from "./state/queryStore";
import { eFileApis } from "./state/e-file-api";
import eFileReducer from "./state/eFileStore";

export const store = configureStore({
  reducer: {
    global: globalReducer,
    queryApi: queryReducer,
    eFileApi: eFileReducer,
    [globalApi.reducerPath]: globalApi.reducer,
    [queryApis.reducerPath]: queryApis.reducer,
    [eFileApis.reducerPath]: eFileApis.reducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([globalApi.middleware, queryApis.middleware, eFileApis.middleware])
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
